import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { NgbDate, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from './http.service';
import {baseUrls} from './appConstant';
import { SubscriptionPlanService } from './services/subscription-plan.service';
declare var $;
declare var jQuery;
@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public viewcontainerhelper: any;
  public headerviewcontainerhelper: any;
  public headercrf: any;
  isBrowser: boolean = false;
  isLoggedIn: boolean = false;
  public frommyaccountforhome = false;
  public signUpTrigger: any = new Subject<any>();
  public loginTrigger: any = new Subject<any>();
  public cameFrom: string = "";
  userDetails : any;
  dateValue: string;
  date: { year: number, month: number };
  public cartquantity = 0;
  public firstname = '';
  public imgSrc = '';
  public subjectTriggerForLoginDetectAtHeader = new Subject<any>();
 public subjectTriggerForPlanPage = new Subject<any>();
 newSubscriptionSubject  = new Subject<any>();
  // cameFrom = '';
  requestedUrl = '';
  routerCheck = new Subject<any>();
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService,
    private subscriptionPlanService: SubscriptionPlanService
    ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      this.loadCountryData();
      if (localStorage.getItem('userDetails')){
        this.isLoggedIn = true;
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        this.firstname = this.userDetails ? this.userDetails?.firstName: '';
        this.imgSrc = this.userDetails && this.userDetails['images'] && this.userDetails['images']['path'] ? baseUrls['images'] + this.userDetails['images']['path'] + this.userDetails['images']['name'] : 'assets/images/profile-picture.png';
      }
      else{
        this.isLoggedIn = false;
      }
      if (Number(localStorage.getItem('cartquantity')) >= 0 && localStorage.getItem("cartquantity") !== null) {
        this.cartquantity = Number(localStorage.getItem('cartquantity')) + 1;
      } else {
        this.cartquantity = 0;
      }
      if(Number(localStorage.getItem("isActivePlan")) >= 0){
        this.isActivePlan = Number(localStorage.getItem("isActivePlan")) >= 0  ? Number(localStorage.getItem("isActivePlan")) : undefined;
      }
    } else{
      this.isBrowser = false;
    }
  }

  public triggerSignUpForm() {
    this.signUpTrigger.next();
  }

  public triggerLoginForm() {
    this.loginTrigger.next();
  }
  public destinationResponse: any={};

  loadCountryData() {
    let Url = "global/destinations";
    this.httpService.getData(Url).subscribe(response => {
      if (response) {
        this.destinationResponse = response;
      }
    });
  }

  customDropdown() {
    function cusDD(select, style) {
      /*Style Switcher*/
      var ddstyle = "";
      if (!style) {
        ddstyle = "cusDD_default";
      } else if (style == "slick dark") {
        ddstyle = "cusDD_slick_d";
      } else if (style == "slick light") {
        ddstyle = "cusDD_slick_l";
      } else {
        ddstyle = style;
      }

      for (var i = 0; i < $(select)?.length; i++) {
        var curr = $($(select)[i]);
        //Replace select with div
        curr.addClass(ddstyle + " cusDD").changeElementType("div");
        //put drop downs in a container
        //Replace options with divs
        curr = $($(select)[i]);
        curr.find("option").wrapAll("<div class='cusDD_options' />");
        curr.find("option").addClass("cusDD_opt").each(function () {
          $(this).changeElementType("div");
        });
        //Add selector and drop down
        curr.prepend("<div class='cusDD_select'><div class='cusDD_arrow'></div></div>");
        //Add default option
        var def = (curr.find("div[selected='selected']")?.length >= 1) ? $(curr.find("div[selected='selected']")) : $(curr.find(".cusDD_opt")[0]);
        curr.find(".cusDD_select").prepend(def.text());

      } //End for loop
      $(document).click(function () {
        $(".cusDD_options").slideUp(200);
        $(".cusDD_arrow").removeClass("active");
      })
      $(select).click(function (e) {
        e.stopPropagation();
        $(this).find(".cusDD_options").slideToggle(200);
        $(this).find(".cusDD_arrow").toggleClass("active");
      })
      $(".cusDD_opt").click(function () {
        $($(this).parent()).siblings(".cusDD_select").contents()[0].nodeValue = $(this).text();
        $(this).parent().find(".cusDD_opt").removeAttr("selected");
        $(this).attr("selected", "selected");
        // console.log($(this));
      });
    } // End function)
    (function ($) {
      $.fn.changeElementType = function (newType) {
        var attrs = {};

        $.each(this[0].attributes, function (idx, attr) {
          attrs[attr.nodeName] = attr.nodeValue;
        });

        this.replaceWith(function () {
          return $("<" + newType + "/>", attrs).append($(this).contents());
        });
      };
    })(jQuery);
    $(document).ready(function () {
      cusDD("#select1", "slick dark");
      cusDD("#select2", "slick dark");
      cusDD("#select3", "slick dark");
      cusDD("#select4", "slick dark");
      cusDD("#select5", "slick dark");
      cusDD("#select6", "slick dark");
      cusDD("#select7", "slick dark");
      cusDD("#select8", "slick dark");
      cusDD("#select9", "slick dark");
    });
  }
  createTabs() {
    $('ul.tabs li').click(function () {
      var tab_id = $(this).attr('data-tab');
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
      $(this).addClass('current');
      $("#" + tab_id).addClass('current');
    });
    $(".acoord-tittle").click(function () {
      $(this).next(".acoord-display").slideToggle();
      $(this).toggleClass("active");
      $(this).parent().toggleClass("active");
    });
  }

  // onDateSelection(date: NgbDate) {
  //   this.dateValue = date.month + "/" + date.day + "/" + date.year;
  // }
  public isOfferPopupValid(): boolean {
    let flag = true;
    if (this.isBrowser) {
      let offerPopUpValidity = this.getSessionStorage('offerPopUpValidity');
      if (offerPopUpValidity) {
        let currentTime = new Date().getTime();
        if (currentTime < (+offerPopUpValidity))
          flag = false;
      }
    }
    return flag;
  }

  public saveOfferPopUpNotShowingValidity(): void {
    let currentTime = new Date().getTime();
    // let extendedTime = currentTime + (1000 * 60 * 5);
    let extendedTime=currentTime+(1000*60*60*24);
    if (this.isBrowser)
      this.setSessionStorage('offerPopUpValidity', "" + extendedTime);
  }

  public setSessionStorage(key: string, value: string): void { // set session storage
    if (this.isBrowser) {
      window.sessionStorage.setItem(key, value);
    }
  }

  public clearSessionStorage(): void {   // clear session storage
    if (this.isBrowser) {
      window.sessionStorage.clear();
    }
  }

  public getSessionStorage(key: string): string {   // get session storage
    if (this.isBrowser) {
      return window.sessionStorage.getItem(key);
    }
  }
  public noOfRecordsPerPage:number=10;

  openCalender(){
    $("#dob-fld").click(function () {
      event.stopPropagation();
      $("#dob-fld").next(".datepicker").css("display", "block");
    });

    $(".datepicker").click(function () {
      event.stopPropagation();
    });

    $("body").click(function () {
      $("#dob-fld").next(".datepicker").css("display", "none");
    });
  }

  scrollbar(){
    $(".scrollBox").mCustomScrollbar({
      axix:"y"
    });
  }

  scroller(){

    // handle links with @href started with '#' only
    $(document).on('click', 'a[href^="#"]', function(e) {
      var demoClasses = document.querySelectorAll('.active');
      demoClasses.forEach(element => {
        element.setAttribute('class','');
      });
      // target element id
      $(this).toggleClass('active');
      var id = $(this).attr('href');

      // target element
      if(id !== '#') {
        var $id = $(id);
        if ($id?.length === 0) {
          return;
        }

        // prevent standard hash navigation (avoid(0) blinking in IE)
        e.preventDefault();

        // top position relative to the document
        var pos = $id.offset().top;
        // console.log(pos-100);

        // animated top scrolling
        $('body, html').animate({scrollTop: pos - 100});
      }

    });
  }
  slider(){
    // console.log('123');
    $(".center").slick({
      dots: true,
      infinite: false,
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1
    });
  }
  deleteAllCookies() {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies?.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  public globalchecklogintoken(): boolean {
    // console.log('123');
    let url = "user/logincheck";
    let data = {
      "userId": localStorage.getItem('userToken')
    };
    this.httpService.postFormData(url, data).subscribe(response => {
      return response.login;
    });
    return false;
  }

  public async triggerlogin(viewcontain, cfr) {
    viewcontain.clear();
    const {LoginComponent} = await import('././login/login.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(LoginComponent)
    );
  }
  public async triggerprofile(viewcontain, cfr) {
    viewcontain.clear();
    const {CreateProfileComponent} = await import('././create-profile/create-profile.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(CreateProfileComponent)
    );
  }
  public async triggersignup(viewcontain, cfr){
    viewcontain.clear();
    const { SignupComponent } = await import('./signup/signup.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(SignupComponent)
    );
  }

  public async triggerforgotpass() {
    this.viewcontainerhelper.clear();
    const {ForgotpassComponent} = await import('./forgotpass/forgotpass.component');
    return this.headerviewcontainerhelper.createComponent(
      this.headercrf.resolveComponentFactory(ForgotpassComponent)
    );
  }
  editAddressInfo;
  public async triggerCreateAddress(viewcontain, cfr) {
    viewcontain.clear();
    const {CreateAddressComponent} = await import('././create-address/create-address.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(CreateAddressComponent)
    );
  }
  isActivePlan;
  isActivePlanUserHave(){
    // https://apimlwdev.clientwork.xyz/userservice/user/info
    this.httpService.getUser("userservice/user/info").subscribe((responseOfUser: any) => {
      if(responseOfUser){
        // console.log('isActivePlanUserHave', responseOfUser);
        if(responseOfUser?.userObj?.isActivePlan >= 0){
          this.isActivePlan = responseOfUser?.userObj?.isActivePlan;
          localStorage.setItem("isActivePlan", responseOfUser?.userObj?.isActivePlan);
          localStorage.setItem("userActivityLog", JSON.stringify(responseOfUser?.userObj?.userActivityLog));
        }
      }
    })
  }
planId;
getSubscriptionPlan(){
  this.subscriptionPlanService.getSubscriptionDetail().subscribe((response:any) => {
    console.log('GlobalServices_ACCOUNT_getSubscriptionPlan', response);
    if(response?.data?._id){
      this.planId = response?.data?._id;
      localStorage.setItem("planId", response?.data?._id);
    }
  });
}
  public async triggerCancelModal(viewcontain, cfr) {
    viewcontain.clear();
    const { CancelModalComponent } = await import('././subscription/cancel-modal/cancel-modal.component');
    return viewcontain.createComponent(
      cfr.resolveComponentFactory(CancelModalComponent)
    );
  }
  userActivityLog;
  moveToMembershipPage(){
    if(this.isBrowser){
      if(localStorage.getItem('userActivityLog')){
        this.userActivityLog = JSON.parse(localStorage.getItem('userActivityLog'))
        if(localStorage?.getItem("planId") || this.planId){
          if(this.userActivityLog?.planSelectionCompleted){
            location.href = `/register/${this.planId ? 
              this.planId : 
              localStorage?.getItem("planId")
            }-${this.userActivityLog?.planSelectionCompleted}`;
          }
          else{
            if(this.userActivityLog?.loginFromUrl){
              location.href = `/register/${this.planId ? 
                this.planId : 
                localStorage?.getItem("planId")
              }-${this.userActivityLog?.loginFromUrl}`;
            }
            else{
              location.href = `/membership/app`
            }
          }
        }
      }
    }
  }
}
